import {
  ApartmentOutlined,
  BorderlessTableOutlined,
  DatabaseOutlined,
  DesktopOutlined,
  DollarCircleOutlined,
  EnvironmentOutlined,
  LineChartOutlined,
  MenuUnfoldOutlined,
  RocketOutlined,
  SearchOutlined,
  TableOutlined,
  TeamOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import {
  Button, Modal, Tooltip,
} from 'antd';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import allActions from '../../../actions';
import { listModes } from '../../../utils/GlobalConstants';
import '../Menu.css';
import QuickSearchMenu from '../quickSearchMenu/QuickSearchMenu';
import styles from '../styles.module.scss';

export default function MainMenu({ isProd, asDropdown, closeMenu }) {
  const location = useLocation().pathname;
  const dispatch = useDispatch();
  const defaultPlants = useSelector((state) => state.commonState.userSettings?.DEFAULT_PLANTS);
  const defaultCCs = useSelector((state) => state.commonState.userSettings?.DEFAULT_COMPANY_CODES);
  const userSettings = useSelector((state) => state.commonState.userSettings);
  const [quicksearchVisible, setQuicksearchVisible] = useState(false);
  const [resetSearch, setResetSearch] = useState(false);

  const clearMaterialState = (mode) => {
    if (mode === listModes.matList) {
      dispatch(allActions.MaterialListActions.clearMaterialStoreState());
      dispatch(allActions.MaterialListActions.selectView(userSettings?.DEFAULT_USER_VIEW));
    } else if (mode === listModes.mmList) {
      dispatch(allActions.MMActions.clearMMStoreState());
      dispatch(allActions.MaterialListActions.selectView(userSettings?.DEFAULT_MM_USER_VIEW));
    }
  };

  const history = useHistory();
  const [quickSearchText, setQuickSearchText] = useState([]);
  const [searchMMR, setSearchMMR] = useState([]);
  const [selectedPlants, setSelectedPlants] = useState([]);
  const [selectedCCs, setSelectedCCs] = useState([]);
  const [funcLocations, setFuncLocations] = useState([]);
  const [storageBins, setStorageBins] = useState([]);
  const [contractNos, setContractNos] = useState([]);
  const [allMaterials, setAllMaterials] = useState(false);
  const [storageLoc, setStorageLoc] = useState([]);
  const [searchFilters, setSearchFilters] = useState({
    availableStock: false,
    stocked: false,
    openDocs: false,
    tiedToTag: false,
    inAgreement: false,
  });
  const [error, setError] = useState({
    material: false,
    contractNo: false,
  });
  const [searchMenuOpened, setSearchMenuOpened] = useState(false);
  const [searchOperators, setSearchOperators] = useState({
    keywords: 'ContainsAND',
    funcLoc: 'EqualTo',
    storageBin: 'ContainsAND',
    contractNos: 'EqualTo',
    plant: 'EqualTo',
    companyCode: 'EqualTo',
    material: 'EqualTo',
    availableStock: 'GreaterThan',
    stocked: 'EqualTo',
    openDocs: 'GreaterThan',
    tiedToTag: 'EqualTo',
    inAgreement: 'EqualTo',
    storageLoc: 'ContainsAND',
  });

  const handleOk = () => {
    if ((defaultPlants?.length > 0 && !_.isEqual(selectedPlants?.sort(), defaultPlants?.sort()))
      || (defaultCCs?.length > 0 && !_.isEqual(selectedCCs?.sort(), defaultCCs?.sort()))) {
      dispatch(allActions.CommonActions.setUseDefaultSettings(false));
    }
    setQuicksearchVisible(false);
    closeMenu && closeMenu();

    const plantList = selectedPlants?.filter((x) => typeof JSON.parse(x) !== 'object');
    dispatch(allActions.CommonActions.setQuickSearchObject({
      quickSearchText,
      searchMMR,
      selectedPlants: plantList,
      selectedCCs,
      funcLocations,
      storageBins,
      contractNos,
      searchOperators,
      storageLoc,
      allMaterialsInContract: allMaterials,
      quickSearchFilters: searchFilters,
    }));
    history.push('/material-list');
  };

  const checkForError = () => Object.values(error).some((item) => item);

  useEffect(() => {
    setSearchMenuOpened(quicksearchVisible);
  }, [quicksearchVisible]);

  return (
    <>
      <Modal
        className="quickSearchModal"
        wrapClassName="quickSearchModalPlacement"
        title="Quick Search"
        onOk={handleOk}
        onCancel={() => setQuicksearchVisible(false)}
        visible={quicksearchVisible}
        okText="Search"
        cancelText="Cancel"
        okButtonProps={{ disabled: error }}
        footer={[
          <Button key="Cancel" onClick={() => setQuicksearchVisible(false)}>Cancel</Button>,
          <Button key="ResetFlds" type="default" onClick={() => setResetSearch(true)}>Reset all fields</Button>,
          <Button key="Search" type="primary" onClick={handleOk} disabled={checkForError()}>Search</Button>,
        ]}
      >
        <QuickSearchMenu
          searchMenuOpened={searchMenuOpened}
          setQuickSearchText={setQuickSearchText}
          quickSearchText={quickSearchText}
          searchMMR={searchMMR}
          setSearchMMR={setSearchMMR}
          selectedPlants={selectedPlants}
          setSelectedPlants={setSelectedPlants}
          selectedCCs={selectedCCs}
          setSelectedCCs={setSelectedCCs}
          funcLocations={funcLocations}
          setFuncLocations={setFuncLocations}
          storageBins={storageBins}
          setStorageBins={setStorageBins}
          contractNos={contractNos}
          setContractNos={setContractNos}
          error={error}
          setError={setError}
          searchOperators={searchOperators}
          setSearchOperators={setSearchOperators}
          resetSearch={resetSearch}
          setResetSearch={setResetSearch}
          allMaterials={allMaterials}
          setAllMaterials={setAllMaterials}
          searchFilters={searchFilters}
          setSearchFilters={setSearchFilters}
          storageLoc={storageLoc}
          setStorageLoc={setStorageLoc}
        />
      </Modal>
      <div
        className={asDropdown ? styles.menuMobile : styles.menu}
        style={{ backgroundColor: isProd ? 'var(--prod-color)' : 'var(--non-prod-color)' }}
      >
        <Tooltip placement="right" title="Quick Search">
          <div
            key="quicksearch"
            onClick={() => {
              setQuicksearchVisible(true);
            }}
            className={`${styles.menuItem} ${styles.asButton}`}
          >
            <SearchOutlined className={styles.icon} />
            <span className={styles.linkText}>Quick Search</span>
          </div>
        </Tooltip>
        <Tooltip placement="right" title="Dashboard">
          <NavLink to="/dashboard" key="/dashboard" className={`${styles.menuItem} ${location === '/dashboard' ? styles.active : ''}`} onClick={() => closeMenu && closeMenu()}>
            <DesktopOutlined className={styles.icon} />
            <span className={styles.linkText}>Dashboard</span>
            <div className={styles.indicator} />
            <div className={styles.bottomDivider} />
          </NavLink>
        </Tooltip>
        <Tooltip placement="right" title="Material List">
          <NavLink
            to="/material-list"
            key="/material-list"
            className={`${styles.menuItem} ${location === '/material-list' || location.includes('material-details') ? styles.active : ''}`}
            onClick={() => {
              clearMaterialState(listModes.matList);
              closeMenu && closeMenu();
            }}
          >
            <TableOutlined className={styles.icon} />
            <span className={styles.linkText}>Material List</span>
            <div className={styles.indicator} />
            <div className={styles.bottomDivider} />
          </NavLink>
        </Tooltip>
        <Tooltip placement="right" title="Material Master">
          <NavLink
            to="/material-master"
            key="/material-master"
            className={`${styles.menuItem} ${location === '/material-master' ? styles.active : ''}`}
            onClick={() => {
              clearMaterialState(listModes.mmList);
              closeMenu && closeMenu();
            }}
          >
            <BorderlessTableOutlined className={styles.icon} />
            <span className={styles.linkText}>Material Master</span>
            <div className={styles.indicator} />
            <div className={styles.bottomDivider} />
          </NavLink>
        </Tooltip>
        <Tooltip placement="right" title="Dynamic Work Lists">
          <NavLink to="/work-lists" key="/work-lists" onClick={() => closeMenu && closeMenu()} className={`${styles.menuItem} ${location === '/work-lists' ? styles.active : ''}`}>
            <UnorderedListOutlined className={styles.icon} />
            <span className={styles.linkText}>Dynamic WL</span>
            <div className={styles.indicator} />
            <div className={styles.bottomDivider} />
          </NavLink>
        </Tooltip>
        <Tooltip placement="right" title="Static Work Lists">
          <NavLink to="/static-work-lists" onClick={() => closeMenu && closeMenu()} key="/static-work-lists" className={`${styles.menuItem} ${location === '/static-work-lists' ? styles.active : ''}`}>
            <DatabaseOutlined className={styles.icon} />
            <span className={styles.linkText}>Static WL</span>
            <div className={styles.indicator} />
            <div className={styles.bottomDivider} />
          </NavLink>
        </Tooltip>
        <Tooltip placement="right" title="Mass Update">
          <NavLink to="/mass-update" key="/mass-update" onClick={() => closeMenu && closeMenu()} className={`${styles.menuItem} ${location === '/mass-update' ? styles.active : ''}`}>
            <RocketOutlined className={styles.icon} />
            <span className={styles.linkText}>Mass Update</span>
            <div className={styles.indicator} />
            <div className={styles.bottomDivider} />
          </NavLink>
        </Tooltip>
        <Tooltip placement="right" title="New Stock Addition">
          <NavLink to="/simulation/new-stock" onClick={() => closeMenu && closeMenu()} className={`${styles.menuItem} ${location === '/simulation/new-stock' ? styles.active : ''}`}>
            <LineChartOutlined className={styles.icon} />
            <span className={styles.linkText}>New Stock</span>
            <div className={styles.indicator} />
            <div className={styles.bottomDivider} />
          </NavLink>
        </Tooltip>
        {/* <Menu.Item key="/simulation/scenario" disabled icon={<DotChartOutlined />}>
          <NavLink to="/simulation/scenario">Scenario Simulation</NavLink>
        </Menu.Item> */}
        <Tooltip placement="right" title="Simulation Results">
          <NavLink to="/simulations" onClick={() => closeMenu && closeMenu()} className={`${styles.menuItem} ${location === '/simulations' ? styles.active : ''}`}>
            <MenuUnfoldOutlined className={styles.icon} />
            <span className={styles.linkText}>Simulations</span>
            <div className={styles.indicator} />
            <div className={styles.bottomDivider} />
          </NavLink>
        </Tooltip>
        <Tooltip placement="right" title="Monetary Impact">
          <NavLink to="/monetary-impact" onClick={() => closeMenu && closeMenu()} key="/monetary-impact" className={`${styles.menuItem} ${location === '/monetary-impact' ? styles.active : ''}`}>
            <DollarCircleOutlined className={styles.icon} />
            <span className={styles.linkText}>Mon. Impact</span>
            <div className={styles.indicator} />
            <div className={styles.bottomDivider} />
          </NavLink>
        </Tooltip>
        <Tooltip placement="right" title="Material Tracking">
          <a
            target="_blank"
            href="https://p03web.statoil.no/sap/bc/ui5_ui5/sap/zpsmm_mat_track/index.html"
            className={styles.menuItem}
            rel="noreferrer"
            onClick={() => closeMenu && closeMenu()}
          >
            <EnvironmentOutlined className={styles.icon} />
            <span className={styles.linkText}>Mat. Tracking</span>
            <div className={styles.indicator} />
            <div className={styles.bottomDivider} />
          </a>
        </Tooltip>
        <Tooltip placement="right" title="Virtual Inventory">
          <a target="_blank" href="https://service.collabor8.no/mm/app/#/vi/home" rel="noreferrer" className={styles.menuItem} onClick={() => closeMenu && closeMenu()}>
            <ApartmentOutlined className={styles.icon} />
            <span className={styles.linkText}>Virtual Inv.</span>
            <div className={styles.indicator} />
            <div className={styles.bottomDivider} />
          </a>
        </Tooltip>
        <Tooltip placement="right" title="Contacts">
          <a target="_blank" href="https://app.powerbi.com/groups/me/apps/b6ae4aca-670d-429f-89e9-6ef93373d7fd/reports/668796e5-d05f-49d6-bb47-e4fcc57ff270/ReportSection" rel="noreferrer" className={styles.menuItem} onClick={() => closeMenu && closeMenu()}>
            <TeamOutlined className={styles.icon} />
            <span className={styles.linkText}>Contacts</span>
            <div className={styles.indicator} />
          </a>
        </Tooltip>
        {/* <Menu.Item key="/feature-timeline" icon={<PullRequestOutlined />}>
          <NavLink to="/feature-timeline">Feature Timeline</NavLink>
        </Menu.Item> */}
      </div>
    </>
  );
}
